module.exports = __webpack_public_path__ + "img/trash-xmark.9df0d07e.svg";